module.exports = __webpack_public_path__ + "img/antigua.699b6b31.svg";